import React from 'react';
import { Industries } from '@99designs/spa-common';

export const IndustriesContext = React.createContext({
    industries: new Industries([]),
});
